<template lang="pug">
  .box-header(:class="{info: alternateMode}")

    .row

      .left-container.col-lg-6.col-xl-5

        label.md-check.m-r-sm(v-if="checkbox")
          input(
            type="checkbox"
            v-model="checkboxValue"
            @change="onCheckboxInput"
          )
          i.indigo

        .search-container(v-if="search")
            .input-wrapper
                input.form-control.input-field(
                    autofocus
                    :disabled="disabled"
                    type="search"
                    :placeholder="searchPlaceholder"
                    slot="search"
                    v-model="query"
                    @keydown.enter="onQueryInput"
                )

                i.glyphicon.glyphicon-search.search-icon
                
            button.btn.btn-fw.white.search-button(@click="onQueryInput") Search

      .col-lg-6.col-xl-7.text-right(slot="actions")

        slot(name="beforeActions")

        datatable-header-actions(
          :actions="actions"
          :alternate-mode="alternateMode"
          :disabled="disabled"
          :selected-count="selectedCount"
          @clear="onCleared"
        )

        slot(name="afterActions")
</template>

<script>
import DatatableHeaderActions from './datatable-header-actions';

export default {
    components: {
        DatatableHeaderActions,
    },

    props: {
        actions: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },

        alternateMode: {
            type: Boolean,
            required: false,
            default: false,
        },

        checkbox: {
            type: Boolean,
            required: false,
            default: false,
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },

        search: {
            type: Boolean,
            required: false,
            default: true,
        },

        selectedCount: {
            type: Number,
            required: false,
            default: 1,
        },

        searchPlaceholder: {
            type: String,
            required: false,
            default: 'Search...',
        },
    },

    data() {
        return {
            checkboxValue: false,
            query: null,
        };
    },

    watch: {
        selectedCount(v) {
            if (v === 0) {
                this.onCleared();
            }
        },
    },

    methods: {
        onCheckboxInput() {
            if (this.checkboxValue) {
                this.$emit('select-all');
            } else {
                this.onCleared();
            }
        },

        onCleared() {
            this.$emit('clear');
        },

        onQueryInput() {
            this.$emit('input', this.query);
        },
    },
};
</script>

<style lang="scss">
.left-container {
    align-items: center;
    display: flex;
}

.info {
    .md-check > i:before {
        border-color: white;
    }

    .md-check > i {
        background-color: white;
    }

    .md-check input[type='checkbox']:checked + i:after {
        color: #6887ff;
    }
}

.search-container {
    display: flex;
    align-items: center;
    width: 100%;
}

.input-wrapper {
    position: relative;
    flex-grow: 1;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1em;
    color: #999;
}

.search-button {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/datatable-header/datatable-header.vue